import { StreamsData } from "@ts/data/StreamsData";
import { simpleForm } from "../core/SimpleForm";
import { Utils } from "../core/Utils";
import { AbstractSection } from "./AbstractSection";

export class YoutubeSection extends AbstractSection {

    public constructor(section: StreamsData) {
        super(section);
        this.renderTarget.classList.add('youtube-wrapper');
    }

    protected onViewRender(): void {
        const data = this.data as StreamsData;
        console.log( data );
        console.log(Utils.minify(`<iframe id="youtube-src" 
                    src="https://www.youtube.com/embed/${data.sharedcode}">
                    title="${data.comment}" 
                    class="spotify-wrapper ${(data.shadow ? 'shadow' : '')}"  
                    allowFullscreen="true">
                </iframe>`));
        this.renderTarget.innerHTML = Utils.minify(`
                <iframe id="youtube-src" 
                    src="https://www.youtube.com/embed/${data.sharedcode}"
                    title="${data.comment}" 
                    class="spotify-wrapper ${(data.shadow ? 'shadow' : '')}"  
                    allowFullscreen="true">
                </iframe>
            <figcaption id="youtube-comment" class="comment">${data.comment}</figcaption>
        `);
    }

    protected onEditRender(): void {
        const data = this.data as StreamsData;
        this.renderTarget.innerHTML = Utils.minify(`
            <iframe id="youtube-src" 
                src="https://www.youtube.com/embed/${data.sharedcode}" 
                title="${data.comment}" 
                class="spotify-wrapper ${(data.shadow?'shadow':'')}"  
                allowFullscreen="true">
            </iframe>
            <figcaption id="youtube-comment" class="comment">${data.comment}</figcaption>
        `);

        if (this.tbar) {
            this.tbar.add('Youtubedelning',
                'Här kan du klistra in en delning från Youtube för att byta ut den Youtubevideo som nu visas',
                'youtube', async () => {
                    await simpleForm('Youtube', 1, 'Klistra delning här', '', 'Delning från Youtube')
                        .then((shared: string) => {
                            if (shared) {
                                let p1 = shared.split('https://youtu.be/');
                                if (p1.length === 1) p1 = shared.split('https://www.youtube.com/embed/')
                                let url = p1[1];
                                if (url.includes('?')) {
                                    const p2 = url.split('?');
                                    url = p2[0];
                                }

                                const iframe = this.renderTarget.querySelector('iframe') as HTMLIFrameElement;

                                iframe.src = `https://www.youtube.com/embed/${url}`;
                                Utils.forceRefresh(iframe);
                            }
                        });
                });
            this.tbar.add('Ändra kommentar',
                `Här kan du lägga till en kommentar. Vill du ingen ha så lämna skrivfältet tomt. Kommentaren
                kan vara fler än en rad om du så vill`,
                'comment', async () => {
                    const commentElement = this.renderTarget.querySelector('figcaption') as HTMLElement;
                    await simpleForm('Ljud', 4, 'Redigera kommentar', commentElement.innerText, 'Min kommentar')
                        .then((text: string) => {
                            commentElement.innerText = text;
                            Utils.forceRefresh(commentElement);
                        });
                });
            this.tbar.add('Skugga',
                `Växla mellan skugga eller ingen skugga`,
                `shadow`, () => {
                    const iframe = this.renderTarget.querySelector('iframe') as HTMLIFrameElement;
                    if (iframe) {
                        Utils.toggleCss(iframe, 'shadow');
                        Utils.forceRefresh(iframe);
                    }

                }
            );

        }
    }

    // https://youtu.be/5exEhqOSS1s?si=9Jh8Xg8e_oRzwqse
    // https://www.youtube.com/embed/nbmZMTuWj28

    //  split https://youtu.be/ | https://www.youtube.com/embed/
    //  [0] => https://youtu.be/
    //  [1] => 5exEhqOSS1s?si=9Jh8Xg8e_oRzwqse
    //
    //  if [1] contains ?
    //  split [1] ?
    //  [0] => 5exEhqOSS1s
    //  [1] => si=9Jh8Xg8e_oRzwqse

    protected parseContent(): void {
        const iframe = this.renderTarget.querySelector('iframe') as HTMLIFrameElement;
        if (iframe === null) return;

        let p1 = iframe.src.split('https://youtu.be/');
        if (p1.length === 1) p1 = iframe.src.split('https://www.youtube.com/embed/');
        (this.data as StreamsData).sharedcode = p1[1];
        if ((this.data as StreamsData).sharedcode.includes('?')) {
            const p2 = (this.data as StreamsData).sharedcode.split('?');
            (this.data as StreamsData).sharedcode = p2[0];
        }

        const div = this.renderTarget.querySelector('figcaption') as HTMLElement;
        (this.data as StreamsData).comment = div.innerText;

        (this.data as StreamsData).shadow = iframe.classList.contains('shadow');
    }

}
